export default {
    type: 'video',
    name: 'Video',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleVideo',
            loader: () => import('./ModuleVideo')
        },
        form: {
            name: 'ModuleVideoForm',
            loader: () => import('./ModuleVideoForm')
        }
    }
};
